import { IChallenge } from '@reducers/challenge/types'
import apiClient from '../../libs/api/libs/apiClient'

const apiChallenge = {
  async getChallenge(id: string): Promise<IChallenge> {
    const { data } = await apiClient.get<IChallenge>(`/challenges/v2/challenge/${id}`)
    return data
  },
  async getChallenges(): Promise<IChallenge[]> {
    const { data } = await apiClient.get<IChallenge[]>('/challenges/v2/list')
    return data
  },
  async getChallengesGlobalRank(type: string): Promise<any> {
    const { data } = await apiClient.get<any>(`/challenges/v2/global-rank/${type}`)
    return data
  },

  async updateChallenge(type, params: IChallenge): Promise<IChallenge> {
    const { data } = await apiClient.post<IChallenge>(`/challenges/v2/settings/save/${type}`, params)
    return data
  },

  async deleteChallenge(id: string): Promise<void> {
    await apiClient.post<IChallenge>(`/challenges/v2/disable-challenge/${id}`)
  },

  async terminateChallenge(id: string): Promise<void> {
    await apiClient.delete<IChallenge>(`/challenges/v2/terminate/${id}`)
  },
}

export default apiChallenge
